export function parseDocumentPageIndex(value: string | null) {
  if (value === null) return undefined;

  const pageIndex = Number(value);
  return Number.isInteger(pageIndex) && pageIndex >= 0 ? pageIndex : undefined;
}

export function parseDocumentRects(value: string | null) {
  if (value === null) return undefined;

  try {
    const rects: unknown = JSON.parse(value);
    if (
      !Array.isArray(rects) ||
      !rects.every(
        (rect) =>
          Array.isArray(rect) &&
          rect.length >= 4 &&
          rect
            .slice(0, 4)
            .every(
              (coordinate) =>
                typeof coordinate === "number" && Number.isFinite(coordinate),
            ) &&
          rect[2] >= 0 &&
          rect[3] >= 0,
      )
    ) {
      return undefined;
    }

    return rects.map((rect) => rect.slice(0, 4) as number[]);
  } catch {
    return undefined;
  }
}
